import React from "react";
import AddMovies from "./AddMovies";

const AdminPage = () => {
  return (
    <>
      <AddMovies />
    </>
  );
};

export default AdminPage;
